import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

export const Logo = props => {
  const { sx, url, isDesktop } = props;
  const navigate = useNavigate();
  const isProduction = process.env.REACT_APP_IS_PRODUCTION === 'true';

  return (
    <Box
      onClick={() => url ? window.location.assign(url) : navigate('/')}
      component="img"
      src={isDesktop ? '/static/logo-2026-mobile.png' : '/static/logo-2026-desktop.png'}
      sx={{ cursor: 'pointer', width: 250, height: 40, ...sx, objectFit: 'contain' }} />
  );
};
